import { render, staticRenderFns } from "./Siesta.vue?vue&type=template&id=01abc675&scoped=true"
import script from "./Siesta.vue?vue&type=script&lang=js"
export * from "./Siesta.vue?vue&type=script&lang=js"
import style0 from "./Siesta.vue?vue&type=style&index=0&id=01abc675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abc675",
  null
  
)

export default component.exports